const getGlobalFromWindow = function getGlobalFromWindowHelper(key) {
  const { seMarketplace } = window;

  if (
    !seMarketplace ||
    !Object.hasOwnProperty.call(seMarketplace, 'site_globals') ||
    !Object.hasOwnProperty.call(seMarketplace.site_globals, key)
  ) {
    return '';
  }

  return window.seMarketplace.site_globals[key];
};


export default getGlobalFromWindow;
